import headerImage from '@/assets/images/home.jpg';
import headerImageMobile from '@/assets/images/home-gradient-min.jpg';

const BANNER_DEFAULT = {
  imageUrl: [headerImage],
  imageUrlMobile: [headerImageMobile],
};

export default BANNER_DEFAULT;
